import {INPUT_ACTION, useRegisterAction} from '../../../inputSystem';
import {useUndoRedo} from '../hooks/useUndoRedo';
import {useSaveAndCopyActions} from './ViewBarButton';

export const useViewBarKeyboardShortcuts = () => {
  const {undo, redo} = useUndoRedo();
  const {save} = useSaveAndCopyActions();

  useRegisterAction(INPUT_ACTION.SAVE_WORKSPACE, () => save.fn(true));
  useRegisterAction(INPUT_ACTION.UNDO_WORKSPACE, () => undo?.(true));
  useRegisterAction(INPUT_ACTION.REDO_WORKSPACE, () => redo?.(true));
};
